import { useState, type FormEvent } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api, ApiError } from '../api';
import { t } from '../i18n';
import { Feld, Fehler } from '../components/ui';

export function ResetPage() {
  const [params] = useSearchParams();
  const [token, setToken] = useState(params.get('token') ?? '');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await api.post('/api/v1/auth/password/reset-complete', { token, newPassword: password });
      navigate('/anmelden', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.code : 'INTERNAL');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-rahmen">
      <div className="karte">
        <h1>{t('auth.reset.title')}</h1>
        <p className="erklaerung">{t('auth.reset.intro')}</p>
        <form onSubmit={submit}>
          <Feld label={t('auth.reset.token')} required>
            <input value={token} onChange={(e) => setToken(e.target.value)} required />
          </Feld>
          <Feld label={t('auth.reset.newPassword')} required hint={t('auth.setup.passwordHint')}>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              minLength={12}
              required
            />
          </Feld>
          <Fehler code={error} />
          <div className="aktionen">
            <button type="submit" className="knopf-primaer" disabled={busy}>
              {t('auth.reset.action')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
